import { object, string, boolean, array, coerce } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

const schema = object({
  name: string({ required_error: IS_REQUIRED }),
  key: string({ required_error: IS_REQUIRED }),
  values: array(string(), { required_error: IS_REQUIRED }),
  userSelectable: boolean().optional(),
  default: boolean().optional(),
  sortingRank: coerce.number().optional(),
});

export const validate = makeValidate(schema);
